export const DOCUMENT_TYPES = {
  TAX_CREDIT: 1,         // Crédito Fiscal
  IMPORT: 2,             // Importación
  EXCLUDED_SUBJECT: 3,   // Sujeto Excluido
  CREDIT_NOTE: 4,        // Nota de Crédito
  DEBIT_NOTE: 5,         // Nota de Débito
  TICKET: 6,             // Ticket
  INVOICE: 7             // Factura
} as const;
